import React from "react";
import Header from "../common/Header/header.jsx";
import Table from "../common/Table/table.jsx";
import Footer from "../common/Footer/footer.jsx";
import {
  educationData,
  professionalData,
  honorsData,
} from "./achievements.jsx";
const EducationalBackgroundPage = () => {
  return (
    <>
      <Header />
      <div className="my-2">
        <Table
          tableHeadings={educationData.educationHeaders}
          tableData={educationData.educationalDetails}
        />
        <Table
          tableHeadings={professionalData.professionalHeaders}
          tableData={professionalData.professionalDetails}
        />
        <Table
          tableHeadings={honorsData.honorsHeaders}
          tableData={honorsData.honorslDetails}
        />
      </div>
      <Footer />
    </>
  );
};

export default EducationalBackgroundPage;
